import React from "react";
import { colors } from "src/config/colors";
import { SelectChangeEvent } from "@mui/material";
import { Box } from "@mui/system";
import { CATEGORIES_FILTER_OPTION } from "src/components/BrandCategoryPage/components/MainBrandSection/components/MainSection/ProductList/PriceSort";

interface SecondCategoriesFilterProps {
  filterOption?: CATEGORIES_FILTER_OPTION;
  handleChange?: (event: SelectChangeEvent) => void;
}

const SecondCategoriesFilter: React.FC<SecondCategoriesFilterProps> = ({
  filterOption,
  handleChange,
}) => {
  return (
    <Box
      display="none"
      justifyContent="flex-end"
      width="100%"
      height="60px"
      bgcolor={colors.darkBlue}
      mt={2}
    >
      {/* <Select
        sx={{
          color: colors.white,
          ".MuiSvgIcon-root": { color: colors.white },
          fontSize: { xs: 13, sm: 15 },
        }}
        value={filterOption}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem value={CATEGORIES_FILTER_OPTION.PriceIncrease}>
          Сначала дешевые
        </MenuItem>
        <MenuItem value={CATEGORIES_FILTER_OPTION.PriceDecrease}>
          Сначала дорогие
        </MenuItem>
      </Select>*/}
    </Box>
  );
};

export default SecondCategoriesFilter;
